// The names that identify this site in an email subject - the sweep's identity
// signal.
//
// Mirrors POST /projects/email-names (.../api/ingestion/email_names.py). The body
// carries the whole LIST rather than an add/remove verb, for the same reason the
// ingestion-mode toggle carries the state asked for: a double-submit then lands
// on the set the operator saw, not on a different one.
import { useMutation, useQueryClient } from "react-query";

import { useAgentsHttp } from "../useAgentsHttp";
import { QK, queryKeys } from "../queryKeys";

// Mirrors project_identifiers.MIN_NAME_CHARS / MAX_NAMES. Duplicated so the form
// can refuse before a round trip; the server refuses too, because a disabled
// control is not an absent one.
export const MIN_NAME_CHARS = 3;
export const MAX_NAMES = 12;

export interface SetEmailProjectNamesResponse {
  project_id: string;
  names: string[];
  // Entries the server dropped (too short, or a case-insensitive duplicate),
  // returned so the form can say so rather than appearing to lose them.
  dropped: string[];
}

export const useSetEmailProjectNames = (projectId: string) => {
  const http = useAgentsHttp();
  const qc = useQueryClient();
  return useMutation<SetEmailProjectNamesResponse, Error, { names: string[] }>(
    (body) =>
      http<SetEmailProjectNamesResponse>("/projects/email-names", {
        project_id: projectId,
        ...body,
      }),
    {
      onSuccess: () => {
        void qc.invalidateQueries(queryKeys.projectGet(projectId));
        void qc.invalidateQueries([QK.projectsList]);
      },
    },
  );
};
